import { render } from "./ProgramsWithHigherAttritionOrDropoutRates.vue?vue&type=template&id=45d5d091"
import script from "./ProgramsWithHigherAttritionOrDropoutRates.vue?vue&type=script&lang=js"
export * from "./ProgramsWithHigherAttritionOrDropoutRates.vue?vue&type=script&lang=js"
script.render = render

export default script